/* eslint-disable @next/next/no-img-element */
/* eslint-disable  @typescript-eslint/no-explicit-any */
// import ReactPlayer from 'react-player';
import {
  Options,
  NodeRenderer,
  documentToReactComponents,
} from '@contentful/rich-text-react-renderer';
import {Block, BLOCKS, INLINES, MARKS} from '@contentful/rich-text-types';
import Image from 'next/image';
// import NextLink from 'next/link';
import Box from '@mui/material/Box';
import {get, isArray} from 'lodash';
import * as Types from 'graphql/types';
import Typography, {TypographyProps} from '@wearesection/bandai-react-components/atoms/Typography';
import Quote from '@wearesection/bandai-react-components/molecules/Quote';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {Link} from '@mui/material';
// import BulletPointNewDetail from '@wearesection/bandai-react-components/atoms/BulletPointNewDetail';
// import BulletPoint from '@wearesection/bandai-react-components/atoms/BulletPoint';

// import TemplateDownload from '@wearesection/bandai-react-components/organisms/TemplateDownload';
// import BlogBlockImage from '@wearesection/bandai-react-components/organisms/BlogBlockImage';
import Hyperlink from '@wearesection/bandai-react-components/organisms/HyperLinkBlog';
// import PlayVideoBiliBili from '@wearesection/bandai-react-components/molecules/PlayVideoBiliBili';
import PlayVideo from '@wearesection/bandai-react-components/molecules/PlayVideo';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import Button from '@wearesection/bandai-react-components/atoms/Button';

import dynamic from 'next/dynamic';
import {handleReturnIDVideo, handleReturnImg, handleReturnTypeVideo} from '~/utils';
import {PLACEHOLDER_IMG} from '~/constants';
import GameDetailCharacterOrganisms from '../game-detail-character/game-detail-character';

const ReactPlayer = dynamic(() => import('react-player'), {
  ssr: true,
});

const HtmlRenderer = dynamic(
  () => import('@wearesection/bandai-react-components/atoms/HtmlRenderer'),
  {
    ssr: false,
  }
);

const TemplateDownload = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/TemplateDownload'),
  {
    ssr: false,
  }
);

const optionsData = (data: Types.News['content']): Options => {
  const options: Options = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: renderInlineEmbeddedEntryTable(data),
    },
  };
  return options;
};

const cssWidthGlobal = {
  width: '100%',
  maxWidth: {
    xs: '672px',
    lg: '740px',
  },
};

const renderInlineEmbeddedEntryTable = (data: Types.News['content']) => {
  const renderer: NodeRenderer = node => {
    const block: any = data?.links.entries.inline.find(
      item => item?.sys.id === node.data.target.sys.id
    );

    return (
      <Image
        src={(block?.media?.url as string) || PLACEHOLDER_IMG}
        alt={block.title ?? ''}
        width={(block.media?.width as number) || 100}
        height={(block.media?.height as number) || 100}
      />
    );
  };

  return renderer;
};

// const renderCenterHeading = (item: any) => {
//   let isCenter = false;
//   const newItem: any = item;
//   if (typeof newItem === 'string' && newItem.includes('<center>')) {
//     return {
//       isCenter: true,
//       newItem: item.replace('<center>', ''),
//     };
//   }
//   if (newItem && newItem?.props && newItem.props?.children) {
//     // children level 1 = string;
//     if (typeof newItem.props?.children === 'string') {
//       if (newItem.props?.children.includes('<center>')) {
//         isCenter = true;
//         newItem.props = {
//           children: item.props.children.replace('<center>', ''),
//         };
//       }
//       return {
//         newItem,
//         isCenter,
//       };
//     }
//   }
//   return {
//     newItem,
//     isCenter,
//   };
// };

const renderHeading = (variant: TypographyProps['variant']) => {
  const cssParagraph = {margin: '0 auto', marginBottom: '16px'};

  const nodeRenderer: NodeRenderer = (_, children) => {
    // const item = (children as any)?.[0] || {};
    // const content = renderCenterHeading(item);
    return (
      <Box
        sx={{
          ...cssParagraph,
          ...cssWidthGlobal,
        }}
      >
        <Typography
          variant={variant}
          sx={{
            color: '#263238',
          }}
          textTransform={undefined}
        >
          {children}
        </Typography>
      </Box>
    );
  };
  return nodeRenderer;
};

const renderParagraph = () => {
  const nodeRenderer: NodeRenderer = (_, children) => {
    return (
      <Box
        sx={{
          ...cssWidthGlobal,
        }}
      >
        {children}
      </Box>
    );
  };

  return nodeRenderer;
};

const renderBlockEmbeddedEntry = (
  data: Types.News['content'],
  isBlog?: boolean,
  dataTranslation?: any
) => {
  const renderer: NodeRenderer = node => {
    const block = data?.links.entries.block.find(item => item?.sys.id === node.data.target.sys.id);

    if (get(block, '__typename') === 'ImageAutoSize') {
      const imageAutoSize = block as Types.ImageAutoSize;
      const items = imageAutoSize?.imagesCollection?.items || [];
      if (items.length) {
        return (
          <Box
            sx={{
              ...cssWidthGlobal,
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              margin: {
                xs: '24px 0px',
                md: '32px 0px',
              },
              padding: '0px 16px',
              gap: '24px',
            }}
          >
            {items.map((item, index) => {
              return (
                <Box
                  key={index}
                  sx={{
                    ...cssWidthGlobal,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  <img src={item?.media?.url || ''} alt="" />
                  {!!item?.caption && (
                    <Typography
                      variant="p4"
                      textTransform={undefined}
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      {item?.caption}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        );
      }
    }

    if (get(block, '__typename') === 'ContentTypeAsset') {
      const asset = block as Types.ContentTypeAsset;

      if (asset.media && asset.media.contentType?.startsWith('image')) {
        return (
          <Box
            sx={{
              ...cssWidthGlobal,
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // paddingY: '30px',
              marginTop: `${asset?.marginTop || 0}px`,
              marginBottom: `${asset?.marginBottom || 0}px`,
              '& img': {
                width: '100% !important',
              },
              '& span': {
                width: '100% !important',
              },
            }}
          >
            <Image
              src={asset.media.url as string}
              alt={asset.alt ?? ''}
              width={asset.media.width as number}
              height={asset.media.height as number}
            />
            {asset?.caption && (
              <Typography
                variant={'p8' as TypographyProps['variant']}
                sx={{
                  width: '100%',
                  maxWidth: '900px',
                  textAlign: 'center',
                  marginTop: {
                    xs: '8px',
                    md: '16px',
                  },
                  lineHeight: {
                    xs: '18px',
                    md: '19px',
                  },
                  overflow: 'hidden',
                  display: '-webkit-box',
                  lineClamp: '3',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  wordBreak: 'break-word',
                  color: '#737373',
                }}
                textTransform={undefined}
              >
                {`${asset?.caption}`.length > 140
                  ? `${asset?.caption}`.substring(0, 140)
                  : asset?.caption || ''}
              </Typography>
            )}
          </Box>
        );
      }

      if (asset.media && asset.media.contentType?.startsWith('video')) {
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              ...cssWidthGlobal,
              height: 'auto',
              '& > div': {
                maxWidth: {
                  ...cssWidthGlobal.maxWidth,
                },
                marginTop: `${asset?.marginTop || 0}px`,
                marginBottom: `${asset?.marginBottom || 0}px`,
                width: '100% !important',
                height: '100% !important',
              },
              flexDirection: 'column',
            }}
          >
            <ReactPlayer controls={true} url={asset.media.url as string} />
            {asset?.caption && (
              <Typography
                variant={'p8' as TypographyProps['variant']}
                sx={{
                  width: '100%',
                  maxWidth: '900px',
                  textAlign: 'center',
                  marginTop: {
                    xs: '8px',
                    md: '16px',
                  },
                  lineHeight: {
                    xs: '18px',
                    md: '19px',
                  },
                  color: '#737373',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  lineClamp: '3',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  wordBreak: 'break-word',
                }}
                textTransform={undefined}
              >
                {`${asset?.caption}`.length > 140
                  ? `${asset?.caption}`.substring(0, 140)
                  : asset?.caption || ''}
              </Typography>
            )}
          </Box>
        );
      }

      if (asset.videoEmbed) {
        return (
          <Container
            sx={{
              position: 'relative',
              zIndex: 1,
              ...cssWidthGlobal,
              padding: '0px !important',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'auto',
                // margin: {
                //   xs: `${asset?.marginMobile || 0}px 0px`,
                //   md: `${asset?.marginDesktop || 0}px 0px`,
                // },
                marginTop: `${asset?.marginTop || 0}px`,
                marginBottom: `${asset?.marginBottom || 0}px`,

                '& div': {
                  gap: '0px',
                },
                '& > div': {
                  maxWidth: {
                    xs: '672px',
                    lg: '740px',
                  },
                  width: '100% !important',
                  height: '100% !important',
                },
                flexDirection: 'column',
              }}
            >
              <PlayVideo
                idVideo={handleReturnIDVideo(asset?.videoEmbed as string)}
                imgUrl={
                  handleReturnImg(asset?.videoEmbed as string, asset) ||
                  asset?.media?.url ||
                  PLACEHOLDER_IMG
                }
                typeVideo={handleReturnTypeVideo(asset?.videoEmbed as string) ?? ''}
                title={''}
                indexBeforeChange={0}
              />
              {asset?.caption && (
                <Typography
                  variant={'p8' as TypographyProps['variant']}
                  sx={{
                    width: '100%',
                    maxWidth: '900px',
                    textAlign: 'center',
                    marginTop: {
                      xs: '8px',
                      md: '16px',
                    },
                    lineHeight: {
                      xs: '18px',
                      md: '19px',
                    },
                    color: '#737373',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    lineClamp: '3',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    wordBreak: 'break-word',
                  }}
                  textTransform={undefined}
                >
                  {`${asset?.caption}`.length > 140
                    ? `${asset?.caption}`.substring(0, 140)
                    : asset?.caption || ''}
                </Typography>
              )}
            </Box>
          </Container>
        );
        // if (handleReturnTypeVideo(asset.videoEmbed as string) === 'bilibili') {
        //   const idVideo = asset?.videoEmbed || '';
        //   return (
        //     <Container>
        //       <Box
        //         sx={{
        //           display: 'flex',
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           maxWidth: '930px',
        //           margin: '0 auto',
        //           marginBottom: '60px',
        //           height: {
        //             xs: '350px',
        //             md: '500px',
        //           },
        //         }}
        //       >
        //         <PlayVideoBiliBili idVideo={idVideo} title={asset?.alt || ''} />
        //       </Box>
        //     </Container>
        //   );
        // } else {

        // }
        //  else {
        //   return (
        //     <Container>
        //       <Box
        //         sx={{
        //           display: 'flex',
        //           justifyContent: 'center',
        //           alignItems: 'center',
        //           margin: {
        //             xs: '30px 0px !important',
        //             md: '60px 0px !important',
        //           },
        //           height: {
        //             xs: '350px',
        //             md: '500px',
        //           },
        //           '& > div': {
        //             maxWidth: {
        //               xs: '672px',
        //               lg: '930px',
        //             },
        //             width: '100% !important',
        //             height: '100% !important',
        //           },
        //         }}
        //       >
        //         <ReactPlayer controls={true} url={asset.videoEmbed} />
        //       </Box>
        //     </Container>
        //   );
        // }
      }
    }

    if (get(block, '__typename') === 'ImageInARow') {
      const contentBlock = block as Types.ImageInARow;

      const handleRenderImageLayout = (data: any) => {
        const layoutImage: any[] = [];

        const arrayImgLayout = data.map((itemImg: any) => {
          return {
            title: itemImg?.alt ?? '',
            linkHref: itemImg?.media?.url ?? '',
            mainImage: itemImg?.media?.url ?? '',
            mainImageNext: '',
            caption:
              `${itemImg?.caption}`.length > 140
                ? `${itemImg?.caption}`.substring(0, 140)
                : itemImg?.caption || '',
            url: itemImg?.url || '',
          };
        });

        layoutImage.push(arrayImgLayout);

        return layoutImage;
      };
      const marginDK = contentBlock?.marginDesktop || 32;
      const marginMB = contentBlock?.marginMobile || 24;

      return (
        <Box
          sx={{
            ...cssWidthGlobal,
            margin: {
              xs: `${marginMB}px 0px`,
              md: `${marginDK}px 0px`,
            },
            '& .MuiContainer-root': {
              padding: '0px',
            },
          }}
        >
          <TemplateDownload
            title={isBlog ? '' : contentBlock?.title ?? ''}
            titleButton={dataTranslation['btn-download']}
            isHorizontalImage={contentBlock?.isLandscapeImage ?? true}
            hideButton={isBlog ? true : contentBlock?.hideDownloadButton ?? true}
            listThumbnail={handleRenderImageLayout(contentBlock?.imagesCollection?.items)}
            columnImageType={!!contentBlock?.typeShowImage}
          />
        </Box>
      );
    }

    if (get(block, '__typename') === 'Quote') {
      const contentBlock = block as Types.Quote;
      const description = documentToReactComponents(contentBlock.content?.json) ?? '';

      return (
        <Container>
          <Box
            sx={{
              ...cssWidthGlobal,
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: {
                xs: '30px',
                md: '60px',
              },
            }}
          >
            <Quote content={description} author={contentBlock?.author} />
          </Box>
        </Container>
      );
    }

    if (get(block, '__typename') === 'Button') {
      const contentBlock = block as Types.Button;
      const label = contentBlock?.label ?? '';
      const isBtnDowLoad = label.toLowerCase()?.includes('download');
      const cssParagraph = {margin: '0 auto'};

      return (
        <Box
          sx={{
            ...cssParagraph,
            ...cssWidthGlobal,
            marginTop: '40px',
            marginBottom: '32px',
            display: 'flex',
            justifyContent: isBtnDowLoad ? 'center' : 'flex-start',
          }}
        >
          <Link
            href={contentBlock?.url ?? '/'}
            target={contentBlock?.target ? '_blank' : '_parent'}
          >
            <Button
              label={label}
              sx={{
                width: '148px',
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor:
                  contentBlock.backgroundColor ?? `${isBtnDowLoad ? '#1E1E1E' : '#e60200'}`,
                color: '#fff',
                '&:hover': {
                  backgroundColor: isBtnDowLoad ? '#e60200' : '#C30000',
                },
              }}
            />
          </Link>
        </Box>
      );
    }

    if (get(block, '__typename') === 'HyperlinkComponent') {
      const contentBlock = block as Types.HyperlinkComponent;
      return (
        <Container>
          <Box
            sx={{
              marginTop: '40px',
              ...cssWidthGlobal,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <Hyperlink
              title={contentBlock?.title ?? ''}
              description={contentBlock?.description}
              mainImage={contentBlock?.thumbnail?.media?.url ?? ''}
              mainImageNext=""
              link={contentBlock?.url ?? ''}
              target={contentBlock?.target ? '_blank' : '_parent'}
            />
          </Box>
        </Container>
      );
    }

    if (get(block, '__typename') === 'GameCharacterList') {
      const contentBlock = block as any;
      const newProps = {
        characterDetailList: contentBlock?.listOfCharactersCollection?.items || [],
        title: contentBlock?.title,
      };
      return (
        <Box
          sx={{
            maxWidth: '100%',
            padding: {
              xs: '44px 0px',
              md: '60px 0px',
            },
            '& .featured-card-carousel': {
              '& .MuiContainer-root': {
                ...cssWidthGlobal,
              },
            },
          }}
        >
          <GameDetailCharacterOrganisms {...newProps} />
        </Box>
      );
    }

    if (get(block, '__typename') === 'NewsGoogleForm') {
      const contentBlock = block as any;
      const iframeContent = contentBlock?.iframeContent || '<div></div>';

      if (iframeContent) {
        return (
          <Box
            style={{
              maxWidth: '100%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                ...cssWidthGlobal,
              }}
            >
              <HtmlRenderer component="div" value={iframeContent} />;
            </Box>
          </Box>
        );
      }
      return '';
    }
  };

  return renderer;
};

const renderBlockEmbeddedAsset = (data: Types.News['content']) => {
  const renderer: NodeRenderer = node => {
    const asset: any = data?.links?.assets?.block?.find(
      item => item?.sys.id === node.data.target.sys.id
    );
    const url = asset?.url || '';

    if (url.includes('images')) {
      return (
        <Box
          sx={{
            ...cssWidthGlobal,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '24px 0px',
            '& img': {
              width: '100% !important',
              height: 'auto',
              borderRadius: '24px',
            },
            '& span': {
              width: '100% !important',
            },
          }}
        >
          <img
            src={asset.url as string}
            alt={asset.alt ?? ''}
            // width={(asset.width as number) ?? 740}
            // height={(asset.height as number) ?? 300}
          />
          {asset?.description && (
            <Typography
              variant={'p8' as TypographyProps['variant']}
              sx={{
                width: '100%',
                maxWidth: '900px',
                textAlign: 'center',
                marginTop: {
                  xs: '8px',
                  md: '16px',
                },
                lineHeight: {
                  xs: '18px',
                  md: '19px',
                },
                color: '#737373',
                overflow: 'hidden',
                display: '-webkit-box',
                lineClamp: '3',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                wordBreak: 'break-word',
              }}
              textTransform={undefined}
            >
              {`${asset?.description}`.length > 140
                ? `${asset?.description}`.substring(0, 140)
                : asset?.description || ''}
            </Typography>
          )}
        </Box>
      );
    }

    if (url.includes('videos')) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            // margin: '24px 0px',
            '& span': {
              width: '100% !important',
            },
            '& > div': {
              ...cssWidthGlobal,
              width: '100% !important',
              height: '100% !important',
            },
            '& video': {
              borderRadius: '24px',
            },
            background: 'red',
          }}
        >
          <ReactPlayer controls={true} url={asset.url as string} />
          {asset?.description && (
            <Typography
              variant={'p8' as TypographyProps['variant']}
              sx={{
                width: '100%',
                maxWidth: '900px',
                textAlign: 'center',
                marginTop: {
                  xs: '8px',
                  md: '16px',
                },
                lineHeight: {
                  xs: '18px',
                  md: '19px',
                },
                color: '#737373',
                overflow: 'hidden',
                display: '-webkit-box',
                lineClamp: '3',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                wordBreak: 'break-word',
              }}
              textTransform={undefined}
            >
              {`${asset?.description}`.length > 140
                ? `${asset?.description}`.substring(0, 140)
                : asset?.description || ''}
            </Typography>
          )}
        </Box>
      );
    }

    return null;
  };

  return renderer;
};

const renderQuote = () => {
  const nodeRenderer: NodeRenderer = (_, children) => {
    let content: any = '';
    if (isArray(children)) {
      const length = children.length;
      content = children.splice(0, length - 1 === 0 ? 1 : length - 1);
    }

    const newContent = content ? <HtmlRenderer component="p" value={content} /> : undefined;
    const newAuthor = children ? <HtmlRenderer component="p" value={children} /> : undefined;

    const args = {
      content: newContent,
      author: newAuthor,
    };
    return (
      <Container>
        <Box
          sx={{
            margin: '20px auto',
            ...cssWidthGlobal,
          }}
        >
          <Quote {...args} />
        </Box>
      </Container>
    );
  };

  return nodeRenderer;
};

const renderUlList = () => {
  const nodeRenderer: NodeRenderer = (_, children) => {
    return (
      <Box
        component={'ul'}
        sx={{
          ...cssWidthGlobal,
          paddingLeft: '18px',
          margin: '8px 0px',
        }}
      >
        {children}
      </Box>
    );
  };

  return nodeRenderer;
};

const Bold = ({children}: {children: any}) => {
  return (
    <Box
      component={'span'}
      className="bold"
      sx={{
        fontWeight: '600',
      }}
    >
      {children}
    </Box>
  );
};

const Italic = ({children}: {children: any}) => {
  return (
    <Box
      component={'span'}
      className="italic"
      sx={{
        fontWeight: '600',
      }}
    >
      {children}
    </Box>
  );
};

const renderOlList = () => {
  const nodeRenderer: NodeRenderer = (_, children) => {
    return (
      <Box
        sx={{
          ...cssWidthGlobal,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        {children}
      </Box>
    );
  };

  return nodeRenderer;
};

export const getOptionsNews = (
  data: Types.News['content'],
  isBlog?: boolean,
  dataTranslation?: any
): Options => {
  const options: Options = {
    renderMark: {
      [MARKS.BOLD]: text => <Bold>{text}</Bold>,
      [MARKS.ITALIC]: text => <Italic>{text}</Italic>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: renderParagraph(),
      [BLOCKS.QUOTE]: renderQuote(),
      [BLOCKS.UL_LIST]: renderUlList(),
      [BLOCKS.OL_LIST]: renderOlList(),
      [BLOCKS.HEADING_1]: renderHeading('h1'),
      [BLOCKS.HEADING_2]: renderHeading('h2'),
      [BLOCKS.HEADING_3]: renderHeading('h3'),
      [BLOCKS.HEADING_4]: renderHeading('h4'),
      [BLOCKS.HEADING_5]: renderHeading('h5'),
      [BLOCKS.HEADING_6]: renderHeading('h6'),
      [BLOCKS.EMBEDDED_ENTRY]: renderBlockEmbeddedEntry(data, isBlog, dataTranslation),
      [BLOCKS.EMBEDDED_ASSET]: renderBlockEmbeddedAsset(data),
      [INLINES.HYPERLINK]: (node, children) => {
        return (
          <Link
            href={node.data.uri}
            target="_blank"
            rel="noreferrer"
            sx={{
              color: '#0169B2 !important',
              position: 'relative',
            }}
          >
            {children}
          </Link>
        );
      },
      [BLOCKS.TABLE]: node => {
        return (
          <Box
            sx={{
              ...cssWidthGlobal,
              margin: {
                xs: '24px 0px',
                md: '32px 0px',
              },
            }}
          >
            <TableContainer>
              <Table sx={{width: '100%'}}>
                <TableHead>
                  <TableRow
                    sx={{
                      background: 'rgb(231, 235, 238)',
                    }}
                  >
                    {(node.content[0] as Block).content.map((cell: any, headCellIndex: number) => (
                      <TableCell
                        key={`head-cell-${headCellIndex}`}
                        vertical-align="top"
                        sx={
                          headCellIndex % 2 === 0
                            ? {
                                borderBottom: '1px solid transparent',
                                verticalAlign: 'top',
                                '& p': {
                                  margin: '0',
                                  textAlign: 'left',
                                },
                                border: '1px solid rgb(174, 193, 204)',
                              }
                            : {
                                border: '1px solid rgb(174, 193, 204)',
                                verticalAlign: 'top',
                                '& p': {
                                  margin: '0',
                                  textAlign: 'left',
                                },
                              }
                        }
                      >
                        {/* {
                        const indx = data?.links.entries.links.find(item => item?.sys.id === node.data.target.sys.id)

                      } */}
                        {cell.content.map((content: any, contentIndex: number) => (
                          <b key={`head-cell-right-${contentIndex}`}>
                            {documentToReactComponents(content, optionsData(data))}
                          </b>
                        ))}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {node.content.slice(1).map((row: any, rowIndex: number) => (
                    <TableRow key={`row-${rowIndex}`}>
                      {row.content.map((cell: any, cellIndex: number) => (
                        <TableCell
                          key={`cell-${rowIndex}-${cellIndex}`}
                          align="center"
                          sx={
                            cellIndex % 2 === 0
                              ? {
                                  verticalAlign: 'top',
                                  '& p': {
                                    margin: '0',
                                    textAlign: 'left',
                                  },
                                  border: '1px solid rgb(174, 193, 204)',
                                }
                              : {
                                  verticalAlign: 'top',
                                  '& p': {
                                    margin: '0',
                                    textAlign: 'left',
                                  },
                                  border: '1px solid rgb(174, 193, 204)',
                                }
                          }
                        >
                          {cell.content.map((content: any, contentIndex: number) =>
                            documentToReactComponents(content, optionsData(data))
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      },
    },
    renderText: text => {
      return text.split('\n').reduce((children: any, textSegment: any, index: any) => {
        return [...children, index > 0 && <br key={index} />, textSegment];
      }, []);
    },
  };
  return options;
};
